import React, { useEffect, useState } from "react";

const API_BASE = "https://api.hfadigitalcreations.com";

const Projectdetails = () => {
  const [applications, setApplications] = useState([]);
  const [filteredApplications, setFilteredApplications] = useState([]);
  const [search, setSearch] = useState("");

  // Modal
  const [selectedApp, setSelectedApp] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);

  // Loading state
  const [loadingId, setLoadingId] = useState(null);

  // Fetch applications on mount
  useEffect(() => {
    fetchApplications();
  }, []);

  const fetchApplications = async () => {
    try {
      const res = await fetch(`${API_BASE}/appdetail`);
      const data = await res.json();
      if (data.status) {
        setApplications(data.data);
        setFilteredApplications(data.data);
      }
    } catch (err) {
      console.error("Error fetching applications:", err);
    }
  };

  // Search
  useEffect(() => {
    if (!search.trim()) {
      setFilteredApplications(applications);
    } else {
      setFilteredApplications(
        applications.filter((app) =>
          app.fullname?.toLowerCase().includes(search.toLowerCase())
        )
      );
    }
  }, [search, applications]);

  // Approve application
  const approveApplication = async (app) => {
    setLoadingId(app.id);
    try {
      const res = await fetch(`${API_BASE}/appdetail/approve`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ user_id: app.user_id }),
      });
      const data = await res.json();
      if (data.status) {
        fetchApplications();
        alert("Application approved and user notified");
      } else {
        alert(data.message);
      }
    } catch (err) {
      console.error(err);
    } finally {
      setLoadingId(null);
    }
  };

  // Export CSV
  const exportCSV = () => {
    if (!applications.length) {
      alert("No data to export");
      return;
    }

    const headers = ["ID", "Full Name", "Email", "Phone", "Message", "Status"];
    const rows = applications.map((app) => [
      app.id,
      app.fullname,
      app.email,
      app.phonenumber,
      app.message,
      app.is_approved === "1"
        ? "Approved"
        : app.is_approved === "2"
        ? "Rejected"
        : "Pending",
    ]);

    const csvContent =
      [headers, ...rows]
        .map((row) =>
          row
            .map((item) =>
              typeof item === "string" && item.includes(",")
                ? `"${item}"`
                : item
            )
            .join(",")
        )
        .join("\n");

    const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = "applications_export.csv";
    a.click();
    URL.revokeObjectURL(url);
  };

  return (
    <div className="p-6">
      <div className="flex justify-between items-center mb-4">
        <h2 className="text-xl font-semibold">Application Requests</h2>
        <button
          onClick={exportCSV}
          className="border px-4 py-2 rounded bg-green-500 text-white hover:bg-green-600"
        >
          Export CSV
        </button>
      </div>

      {/* Search */}
      <input
        type="text"
        placeholder="Search applications..."
        value={search}
        onChange={(e) => setSearch(e.target.value)}
        className="border rounded w-full p-2 mb-4"
      />

      {/* Cards */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
        {filteredApplications.map((app) => (
          <div
            key={app.id}
            className="border rounded p-4 bg-white shadow-sm flex flex-col justify-between"
          >
            <div>
              <h3 className="font-semibold text-lg">{app.fullname}</h3>
              <p className="text-gray-500 text-sm">{app.email}</p>
              <p className="text-gray-500 text-sm">{app.phonenumber}</p>
              <span
                className={`inline-block mt-2 text-xs px-2 py-1 rounded ${
                  app.is_approved === "1"
                    ? "bg-green-100 text-green-700"
                    : app.is_approved === "2"
                    ? "bg-red-100 text-red-700"
                    : "bg-yellow-100 text-yellow-700"
                }`}
              >
                {app.is_approved === "1"
                  ? "Approved"
                  : app.is_approved === "2"
                  ? "Rejected"
                  : "Pending"}
              </span>
            </div>

            {/* Actions */}
            <div className="flex justify-between items-center mt-4">
              <button
                onClick={() => {
                  setSelectedApp(app);
                  setIsModalOpen(true);
                }}
                className="text-blue-600 hover:underline"
              >
                Quick View
              </button>
              {app.is_approved !== "1" && (
                <button
                  onClick={() => approveApplication(app)}
                  disabled={loadingId === app.id}
                  className="bg-green-500 text-white px-3 py-1 rounded hover:bg-green-600 disabled:opacity-50"
                >
                  Approve
                </button>
              )}
            </div>
          </div>
        ))}
      </div>

      {/* Modal */}
      {isModalOpen && selectedApp && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-white rounded p-6 w-full max-w-md shadow-lg relative">
            <h3 className="text-lg font-semibold mb-2">{selectedApp.fullname}</h3>
            <p className="text-gray-500 mb-4">{selectedApp.email}</p>
            <p className="text-sm mb-2">
              <strong>Phone:</strong> {selectedApp.phonenumber}
            </p>
            <p className="text-sm mb-2">
              <strong>Message:</strong> {selectedApp.message}
            </p>
            {selectedApp.uploadfile && (
              <p className="text-sm mb-4">
                <strong>File:</strong>{" "}
                <a
                  href={selectedApp.uploadfile}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-blue-600 underline"
                >
                  View File
                </a>
              </p>
            )}

            <button
              onClick={() => setIsModalOpen(false)}
              className="absolute top-2 right-2 text-gray-500 hover:text-gray-700"
            >
              ✕
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default Projectdetails;
